<nz-drawer
	[nzVisible]="isArtifactDrawerVisible"
	[nzWidth]="900"
	nzPlacement="right"
	[nzClosable]="false"
	[nzBodyStyle]="{ 'padding-top': '10px', 'padding-bottom': '10px' }"
	(nzOnClose)="closeDrawer()"
>
	<ng-container *nzDrawerContent>
		<ng-container *ngIf="selectedArtifact as currentArtifact">
			<div class="artifact-drawer-shell">
			<div class="artifact-drawer-header">
				<div class="artifact-drawer-header-left">
					<div class="artifact-view-toggle">
						<button nz-button class="artifact-view-button" [class.code-selected]="artifactView === 'code'" (click)="changeArtifactView('code')" title="Code view">
							<svg-icon src="assets/icons/code.svg" class="code-icon" />
						</button>
						<button nz-button class="artifact-view-button" [class.eye-selected]="artifactView === 'preview'" (click)="changeArtifactView('preview')" title="Preview view">
							<svg-icon src="assets/icons/eye-opened.svg" />
						</button>
					</div>

					<div class="artifact-drawer-title-wrap">
						<h2 class="artifact-drawer-title">{{ currentArtifact.title }}</h2>
						<div class="artifact-type-display">
							<svg-icon src="assets/icons/code.svg" class="artifact-type-icon code-icon" />
							<span class="artifact-type-text">{{ currentArtifact.type }}</span>
						</div>
					</div>
				</div>

				<div class="artifact-drawer-header-right">
					<button nz-button nzType="text" (click)="downloadSelectedArtifact()" title="Download artifact">
						<svg-icon src="assets/icons/download.svg" class="download-icon-black" />
					</button>
					<button nz-button nzType="text" (click)="closeDrawer()" title="Close drawer">
						<svg-icon src="assets/icons/close-icon.svg" />
					</button>
				</div>
			</div>

			<div class="artifact-preview">
				<div class="artifact-preview-content">
					<ng-container *ngIf="artifactView === 'preview'; else codeContent">
						<div style="height: 100%" [innerHTML]="safeArtifactHtml"></div>
					</ng-container>
					<ng-template #codeContent>
						<div class="artifact-code" style="max-height: 100%">
							<pre><code>{{ currentArtifact.htmlContent }}</code></pre>
						</div>
					</ng-template>
				</div>
			</div>
			</div>
		</ng-container>
	</ng-container>
</nz-drawer>
